export const PREMIUM_PLAN_PRODUCT_TYPE_ID = '8b1b47e6-9f58-4e59-b147-cac894bec8da';
export const WIXEL_PRODUCT_TYPE_ID = 'bd2de69a-4c3e-49c4-b5f3-e7362babc396';
export const WIXEL_MAX_PLAN_PRODUCT_FAMILY_ID = '839bb67c-ee9d-4e13-b316-44952bcac2e8';
export const WIXEL_PRO_PLAN_PRODUCT_FAMILY_ID = '29631a87-34f9-45ea-a08f-0098df462462';
export const ECLIPSE_PRODUCT_TYPE_ID = '8b1b47e6-9f58-4e59-b147-cac894bec8da';
//# sourceMappingURL=consts.js.map